import React from "react";
import { useSidebar } from "@/domains/core/layout/useSidebar";
import { CollapsedSidebar } from "./CollapsedSidebar";
import { ExpandedSidebar } from "./ExpandedSidebar";

/**
 * Modern Sidebar Component
 *
 * This component conditionally renders either the CollapsedSidebar or ExpandedSidebar
 * based on the sidebar state. This approach provides:
 *
 * - Better performance (only renders the needed component)
 * - Cleaner code separation
 * - Easier maintenance
 * - Smaller bundle size per state
 */
export const ModernSidebar: React.FC = () => {
  const { isOpen } = useSidebar();

  // Conditionally render the appropriate sidebar component
  return isOpen ? <ExpandedSidebar /> : <CollapsedSidebar />;
};
